import gql from "graphql-tag";

export const ALL_CUSTOMERS = gql`
    query ALL_CUSTOMERS($page: Int!, $perPage: Int!, $searchKeyword: String) {
        institutions (page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                typeId {
                    publicId,
                    name,
                    tier {
                        publicId,
                        name
                    }
                }
                name,
                institutionCode,
                phoneNumber,
                email,
                pin,
                postalCode,
                bankName,
                branch,
                branchNumber,
                accountName,
                accountNumber,
                invoicingPeriod,
                expectedPaymentPeriod,
                activeState
            }
        }
    }
`;

export const ALL_CUSTOMERS_SIMPLE = gql`
    query ALL_CUSTOMERS_SIMPLE($page: Int!, $perPage: Int!, $searchKeyword: String) {
        institutions (page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                name,
                email,
            }
        }
    }
`;

export const SINGLE_CUSTOMER = gql`
    query SINGLE_CUSTOMER($id: String!, $branchCurrentPage: Int, $branchSearchKeyword: String) {
        institution (id: $id) {
            publicId,
            typeId {
                publicId,
                name
            }
            name,
            pin,
            description,
            phoneNumber,
            email,
            postalCode,
            bankName,
            branch,
            accountName,
            accountNumber,
            invoicingPeriod,
            expectedPaymentPeriod,
            activeState,
            lastUpdatedBy {
                name
            }
            branches {
                publicId,
                name,
                email,
                phoneNumber,
                zoneId {
                    publicId,
                    name,
                },
                addressLine1,
                town,
                street,
                longi,
                lat,
                automaticDiscountPrecentage,
                automaticSurchargePrecentage,
                personInCharge,
            },
            branchesPaginated (page: $branchCurrentPage, perPage: 30, searchKeyword: $branchSearchKeyword, showDeleted: false) {
                page,
                pages,
                total,
                objects {
                    publicId,
                    name,
                    email,
                    phoneNumber,
                    customerCode
                    zoneId {
                        publicId,
                        name,
                    },
                    addressLine1,
                    town,
                    street,
                    longi,
                    lat,
                    automaticDiscountPrecentage,
                    automaticSurchargePrecentage,
                    personInCharge,
                    warehouseConsigneeCode,
                }
            }
        }
    }
`;

export const ADD_NEW_CUSTOMER = gql`
    mutation ADD_NEW_CUSTOMER($typeId: String!, $name: String!, $pin: String!, $phoneNumber:String!, $email:String!, 
        $postalCode: String!, $bankName: String!, $branch: String!, $accountName:String!, $accountNumber: String!, $invoicingPeriod: Int!, $expectedPaymentPeriod: Int!){
        institution(typeId: $typeId, name: $name, pin: $pin, phoneNumber: $phoneNumber, email: $email, postalCode: $postalCode, 
            bankName: $bankName, branch: $branch, accountName: $accountName, accountNumber: $accountNumber, invoicingPeriod: $invoicingPeriod, expectedPaymentPeriod: $expectedPaymentPeriod) {
            institution {
                publicId,
                name,
            }
        }
    }
`;

export const UPDATE_CUSTOMER = gql`
    mutation UPDATE_CUSTOMER($id: ID!, $typeId: String!, $name: String!, $pin: String!, $phoneNumber:String!, $email:String!,
        $postalCode: String!, $bankName: String!, $branch: String!, $accountName:String!, $accountNumber: String!, $invoicingPeriod: Int!, $expectedPaymentPeriod: Int!){
        institution(id: $id, typeId: $typeId, name: $name, pin: $pin, phoneNumber: $phoneNumber, email: $email, postalCode: $postalCode,
            bankName: $bankName, branch: $branch, accountName: $accountName, accountNumber: $accountNumber, invoicingPeriod: $invoicingPeriod, expectedPaymentPeriod: $expectedPaymentPeriod) {
            institution {
                publicId,
                name,
            }
        }
    }
`;

export const UPDATE_CUSTOMER_STATUS = gql`
    mutation UPDATE_CUSTOMER_STATUS($id: ID!) {
        institutionStatus(id: $id) {
            institution {
                publicId,
                name,
            }
        }
    }
`


// CUSTOMER BRANCH
export const ALL_CUSTOMER_BRANCHES = gql`
    query ALL_CUSTOMER_BRANCHES($page: Int!, $perPage: Int!, $branchSearchKeyword: String) {
        branches (page: $page, perPage: $perPage, searchKeyword: $branchSearchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                name,
                validOrderProducts {
                    publicId,
                    productName,
                    code
                }
                longi,
                lat,
                validOrderDays {
                    publicId,
                    weekday,
                    calendarCode
                },
            }
        }
    }
`;

export const ALL_CUSTOMER_BRANCHES_SANS_PRODUCTS = gql`
    query ALL_CUSTOMER_BRANCHES_SANS_PRODUCTS($page: Int!, $perPage: Int!, $branchSearchKeyword: String) {
        branches (page: $page, perPage: $perPage, searchKeyword: $branchSearchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                name,
            }
        }
    }
`;

export const SINGLE_CUSTOMER_BRANCH = gql`
    query SINGLE_CUSTOMER_BRANCH($id: String!, $orderSearchKeyword: String, $orderCurrentPage: Int) {
        branch (id: $id){
            publicId,
            name,
            institutionId {
                publicId,
                name
            },
            zoneId {
                publicId,
                name,
            },
            phoneNumber,
            email,
            addressLine1,
            town,
            street,
            longi,
            lat,
            automaticDiscountPrecentage,
            automaticSurchargePrecentage,
            personInCharge,
            warehouseConsigneeCode,
            contacts {
                publicId
                name,
                phoneNumber,
                secondaryPhoneNumber,
                email,
                createdAt
            }
            orders {
                publicId,
                invoiceId,
                deliveryDate
            },
            ordersPaginated (page: $orderCurrentPage, perPage: 30, searchKeyword: $orderSearchKeyword, showDeleted: false, status: [], payment: [], deliveryDates: []) {
                page,
                pages,
                total,
                objects {
                    publicId,
                    invoiceId,
                    deliveryDate,
                    orderedBy,
                    createdAt,
                    orderTotal,
                    paymentReceivedDate,
                    status{
                        orderStatusName
                    },
                }
            }
        }
    }
`;

export const SIMPLE_SINGLE_CUSTOMER_BRANCH = gql`
    query SIMPLE_SINGLE_CUSTOMER_BRANCH($id: String!) {
        branch (id: $id){
            publicId,
            name,
            phoneNumber,
            email,
            addressLine1,
            town,
            street,
            longi,
            lat,
            warehouseConsigneeCode,
            validOrderDays {
                publicId,
                weekday,
                calendarCode
            },
            validOrderProducts {
                publicId,
                productName,
                code
            }
        }
    }
`;

export const ADD_NEW_CUSTOMER_BRANCH = gql`
    mutation UPDATE_CUSTOMER_BRANCH($name: String!, $institutionId: String!, $phoneNumber:String!, $email:String!,
        $zoneId: String!, $addressLine1: String!, $town: String!, $longi:String!, $lat: String!, $street: String!, $automaticDiscountPrecentage: Int, $automaticSurchargePrecentage: Int, $personInCharge: String, $warehouseConsigneeCode: String){
        branch(institutionId: $institutionId, zoneId: $zoneId, name: $name, phoneNumber: $phoneNumber, email: $email,
            addressLine1: $addressLine1, town: $town, longi: $longi, lat: $lat, street: $street, automaticDiscountPrecentage: $automaticDiscountPrecentage, automaticSurchargePrecentage: $automaticSurchargePrecentage, personInCharge: $personInCharge, warehouseConsigneeCode: $warehouseConsigneeCode){
            branch {
                publicId,
                name
            }
        }
    }
`;

export const UPDATE_CUSTOMER_BRANCH = gql`
    mutation UPDATE_CUSTOMER_BRANCH($id: ID!, $name: String!, $institutionId: String!, $phoneNumber:String!, $email:String!,
    $zoneId: String!, $addressLine1: String!, $town: String!, $longi:String!, $lat: String!, $street: String!, $automaticDiscountPrecentage: Int, $automaticSurchargePrecentage: Int, $personInCharge: String, $warehouseConsigneeCode: String){
        branch(id: $id, institutionId: $institutionId, zoneId: $zoneId, name: $name, phoneNumber: $phoneNumber, email: $email, 
            addressLine1: $addressLine1, town: $town, longi: $longi, lat: $lat, street: $street, automaticDiscountPrecentage: $automaticDiscountPrecentage, automaticSurchargePrecentage: $automaticSurchargePrecentage, personInCharge: $personInCharge, warehouseConsigneeCode: $warehouseConsigneeCode){
            branch {
                publicId,
                name
            }
        }
    }
`;

// SALES PROFILES

export const ALL_SALES_PROFILES = gql`
    query ALL_SALES_PROFILES($page: Int!, $perPage: Int!, $searchKeyword: String) {
        feedbacks (page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                recordName
                customer {
                    publicId,
                    name
                },
                name
                zone {
                    publicId,
                    name
                },
                feedback,
                capacity,
                monthlyConsumption,
                supplierComplaints,
                brands {
                    name
                },
                suppliers {
                    name
                },
                feedbackOwner {
                    publicId,
                    name
                },
                productsOfInterest {
                    publicId,
                    productCode {
                        publicId,
                        productName
                    }
                },
                personsInCharge {
                    title,
                    name,
                    tel,
                    email
                },
                currentStatus {
                    status {
                        name,
                        color
                        publicId
                    }
                },
                lastUpdatedBy {
                    publicId,
                    name,
                    updatedAt
                }
            }
        }
    }
`;

export const SINGLE_SALES_PROFILE = gql`
    query SINGLE_SALES_PROFILE($id: String!, $turnoverCurrentPage: Int, $turnoverSearchKeyword: String) {
        feedback (id: $id) {
            publicId,
            recordName
            customer {
                publicId,
                name
            },
            name,
            zone {
                publicId,
                name
            },
            feedback,
            capacity,
            monthlyConsumption,
            supplierComplaints,
            currentStatus {
                status {
                    name,
                    color
                }
            },
            brands {
                publicId
                name
            },
            suppliers {
                publicId
                name
            },
            productsOfInterest {
                publicId,
                productCode {
                    publicId,
                    productName
                }
            },
            personsInCharge {
                publicId
                title,
                name,
                tel,
                email
            },
            ownership {
                publicId,
                userId {
                    name
                },
                createdAt
                lastUpdatedBy {
                    publicId,
                    name
                }
            },
            comments {
                publicId,
                comment,
                createdAt,
                lastUpdatedBy {
                    name
                }
            },
            visits {
                publicId,
                salesType {
                    publicId,
                    name
                },
                visitDate,
                staff {
                    publicId
                    name
                }
                createdAt
            },
            turnoverPaginated (page: $turnoverCurrentPage, perPage: 30, searchKeyword: $turnoverSearchKeyword, showDeleted: false) {
                page,
                total,
                objects {
                    publicId,
                    productCode {
                        publicId,
                        productName
                    },
                    visitDate,
                    weekVisited
                    demo,
                    currentStock,
                    lastUpdatedBy {
                        publicId,
                        name
                    }
                }
            }
            createdAt,
            lastUpdatedBy {
                publicId,
                name
            }
        }
    }
`;

export const ADD_NEW_SALES_PROFILE = gql`
    mutation ADD_NEW_SALES_PROFILE($customer: String, $name: String, $zone: String, $status: String, $feedbackData: String, $capacity: Int, $monthlyConsumption: String, 
        $supplierComplaints: String, $brands: [String], $suppliers: [String], $productsOfInterest: [String], $personsInCharge: [PersonInChargeInputType]){
        feedback(customer: $customer, name: $name, zone: $zone, status: $status, feedbackData: $feedbackData, capacity: $capacity, monthlyConsumption: $monthlyConsumption, 
            supplierComplaints: $supplierComplaints, brands: $brands, suppliers: $suppliers, productsOfInterest: $productsOfInterest, personsInCharge: $personsInCharge){
            feedback {
                publicId
            }
        }
    }
`;

export const UPDATE_SALES_PROFILE = gql`
    mutation UPDATE_SALES_PROFILE($id: ID!, $customer: String, $name: String, $zone: String, $status: String, $feedbackData: String, $capacity: Int, $monthlyConsumption: String,
        $supplierComplaints: String, $brands: [String], $suppliers: [String], $productsOfInterest: [String], $personsInCharge: [PersonInChargeInputType]){
        feedback(id: $id,customer: $customer, name: $name, zone: $zone, status: $status, feedbackData: $feedbackData, capacity: $capacity, monthlyConsumption: $monthlyConsumption,
            supplierComplaints: $supplierComplaints, brands: $brands, suppliers: $suppliers, productsOfInterest: $productsOfInterest, personsInCharge: $personsInCharge){
            feedback {
                publicId
            }
        }
    }
`;

export const CHANGE_SALES_PROFILE_OWNERSHIP = gql`
    mutation CHANGE_SALES_PROFILE_OWNERSHIP($userId: String!, $feedback: String!){
        feedbackOwnership(userId: $userId, feedback: $feedback){
            feedbackOwnership {
                publicId,
            }
        }
    }
`;

export const ADD_SALES_PROFILE_TURNOVER = gql`
    mutation ADD_SALES_PROFILE_TURNOVER($feedbackId: String!, $visitDate: Date!, $productCode: String!, $currentStock: Int, $demo: Int){
        turnOver(feedbackId: $feedbackId, visitDate: $visitDate, productCode:$productCode, currentStock:$currentStock, demo:$demo){
            turnOver {
                publicId
            }
        }
    }
`;

export const ADD_SALES_PROFILE_VISITS = gql`
    mutation ADD_SALES_PROFILE_VISITS($feedback: String!, $salesType: String!){
        salesRollCall(feedback: $feedback, salesType: $salesType){
            salesRollCall{
                publicId
            }
        }
    }
`;

export const ADD_SALES_PROFILE_COMMENTS = gql`
    mutation ADD_SALES_PROFILE_COMMENTS($feedbackPublicId: String!, $comment: String!){
        thread(feedbackPublicId: $feedbackPublicId, comment: $comment){
            thread{
                publicId
            }
        }
    }
`;

// SALES VISIT TYPES

export const ALL_SALES_VISIT_TYPES = gql`
    query ALL_SALES_VISIT_TYPES($page: Int!, $perPage: Int!) {
        salesTypeList (page: $page, perPage: $perPage) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                name,
                createdAt
            }
        }
    }
`;

// SALES PROFILE STATUS

export const ALL_SALES_PROFILE_STATUS = gql`
    query ALL_SALES_PROFILE_STATUS($page: Int!, $perPage: Int!) {
        statuses (page: $page, perPage: $perPage) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                name,
                description,
                color,
                createdAt
            }
        }
    }
`;

export const SINGLE_SALES_PROFILE_STATUS = gql`
    query SINGLE_SALES_PROFILE_STATUS($id: Int!) {
        status (id: $id) {
            publicId,
            name,
            description,
            color,
            createdAt
        }
    }
`;
